import styled, {css} from 'styled-components';

import {flipOnLTR} from '~/shared/theme/utils';
import {Link as _Link} from '~/shared/router';

export const ContentCell = styled.td`
  display: inline-flex;
  height: 100%;
  align-items: center;
  line-height: 1;
  cursor: ${({pointer}) => (pointer ? 'pointer' : 'inherit')};
  width: ${({cellWidth}) => `${cellWidth || 30}px`};
  ${({height}) => height && `height: ${height}px;`}
  color: ${({theme, marked}) => (marked ? theme.userReport.general.markedRowText : theme.userReport.general.text)};
  ${({center}) =>
    center &&
    `
    text-align: center;
    justify-content: center;
  `}
`;

export const BorderHider = styled.div`
  background-color: ${({theme}) => theme.userReport.general.background};
  width: 30px;
  height: 2px;
  top: -20px;
  ${({headerName}) =>
    headerName === 'menu' &&
    flipOnLTR`
    left: -27px;
  `}
`;

export const Text = styled.div`
  font-weight: ${({isBold}) => (isBold ? 'bold' : 'normal')};
  color: ${({theme, blue}) => (blue ? theme.userReport.transactionTable.text.collapseButton : 'inherit')};
  ${({isFullWidthCell}) =>
    isFullWidthCell &&
    `
    word-break: break-word;
    white-space: normal;
    direction: rtl;
  `}
  ${({centered}) =>
    centered &&
    css`
      text-align: center;
      ${flipOnLTR`padding-left: 25px`};
    `}
`;
